export default theme => ({
  root: {
    marginBottom: theme.spacing(2.5),
  },
});
